import { render, staticRenderFns } from "./OdontogramaDente.vue?vue&type=template&id=0ac3ff60&scoped=true"
import script from "./OdontogramaDente.vue?vue&type=script&lang=js"
export * from "./OdontogramaDente.vue?vue&type=script&lang=js"
import style0 from "./OdontogramaDente.vue?vue&type=style&index=0&id=0ac3ff60&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac3ff60",
  null
  
)

export default component.exports